<template>
  <div class="main">
    <div class="wrap-particles">
      <div class="main-content">
        <b-navbar style="background-color: #fff;">
          <b-navbar-brand>
            <img src="@/assets/logo.png" style="height:40px;">
          </b-navbar-brand>
        </b-navbar>

        <div class="container py-4 text-center h-75">
          <h1 class="text-white">Create New Game</h1>

          <div class="row d-flex justify-content-center align-items-center h-100">
            <div class="col-lg-6 p-2">
              <div class="card h-100 px-5 py-4">
                <img class="card-img-top w-50 align-self-center" src="@/assets/mode-02.png">
                <div class="card-body d-flex flex-column">
                  <h3 class="card-title text-uppercase">Mining</h3>
                  <p class="card-text">
                    Mine space gems as much as you can and sell it to be the richest team!
                  </p>
                  <b-button to="/create/mining" class="mt-auto rounded-0 btn btn-dark text-uppercase">Select</b-button>
                </div>
              </div>
            </div>

            <div class="col-lg-6 p-2">
              <div class="card h-100 px-5 py-4">
                <img class="card-img-top w-50 align-self-center" src="@/assets/mode-01.png">
                <div class="card-body d-flex flex-column">
                  <h3 class="card-title text-uppercase">Exploration</h3>
                  <p class="card-text">
                    Spacecraft racing between two teams. Go to the destination planet first to win the game!
                  </p>
                  <b-button to="/create/exploration" class="mt-auto rounded-0 btn btn-dark text-uppercase">Select
                  </b-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <vue-particles color="#ffffff" :particleOpacity="0.3" :particlesNumber="80" shapeType="circle" :particleSize="5"
        :lineLinked="false" :moveSpeed="1" :hoverEffect="false" :clickEffect="false" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'create'
}
</script>

<style scoped>
.main {
  width: 100vw;
  min-height: 100vh;
  /* overflow: hidden; */
  background-color: #000;
}
</style>

